import {formatUTCTime, getInternationalDate} from "../../services/Format/Date";

const createSlotTimeRange = (startTime, endTime, timeZone) => {
  return `${formatUTCTime(startTime, timeZone)} - ${formatUTCTime(
    endTime,
    timeZone
  )}`;
};

const prepareQRDisplayData = (data) => {
  const {
    storeName,
    startTime,
    endTime,
    noOfPeople,
    userId,
    status,
    businessUnit,
    uuid,
    location,
    serviceType,
    timeZone,
    country,
    storeType,
    storeId,
    bookingId,
  } = data;
  const displayData = {
    bookingId: bookingId ? bookingId : uuid,
    businessUnit,
    storeName,
    storeId,
    slotDate: getInternationalDate(startTime, timeZone),
    slotTimeRange: createSlotTimeRange(startTime, endTime, timeZone),
    noOfPeople,
    startTime,
    endTime,
    userId,
    status,
    timeZone,
    location,
    serviceType: serviceType[0],
    apiResponse: JSON.stringify(data),
    country,
    storeType,
  };
  return displayData;
};

export {prepareQRDisplayData};
